module.exports = global["PIXI"] = require("-!/Users/jesper/WebstormProjects/king-rail/node_modules/phaser/build/custom/pixi.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/phaser/build/custom/pixi.js
 ** module id = 300
 ** module chunks = 1
 **/